import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Clock, AlertTriangle } from 'lucide-react';

export function TestMode() {
  const { courseId } = useParams<{ courseId: string }>();

  // TODO: Implement test mode (timed, no hints, shuffled questions)
  return (
    <div className="test-mode">
      <Link to={`/course/${courseId}`} className="back-link">
        <ArrowLeft size={18} />
        Zurück
      </Link>

      <div className="test-info">
        <Clock size={48} />
        <h1>Test-Modus</h1>
        <p>Simuliere eine echte Prüfung</p>

        <ul className="test-rules">
          <li>Zeitlimit: 15 Minuten</li>
          <li>Keine Erklärungen</li>
          <li>Zufällige Reihenfolge</li>
          <li>Ergebnis am Ende</li>
        </ul>

        <div className="test-warning">
          <AlertTriangle size={20} />
          <span>Du kannst nicht pausieren!</span>
        </div>

        <button className="btn-primary">
          Test starten
        </button>
      </div>
    </div>
  );
}
